<div [class]="_computedClass()" (click)="clickCard()">
  <div class="bg-components-background-neutral-lightest p-sm shadow-bottom flex rounded-md">
    <div class="flex flex-1 flex-col">
      <span class="text-content-primary component-medium-semibold"
        >{{ certification().nom }} - {{ certification().codeFiche }}</span
      >
      @if (certification().niveau) {
        <span class="text-content-secondary component-small-medium">Niveau : {{ certification().niveau }}</span>
      }
    </div>
    @if (actions().length) {
      <button [hlmDropdownMenuTrigger]="dropdown" (click)="$event.stopPropagation()" hlmBtn variant="ghost" size="icon">
        <ng-icon name="lucideEllipsisVertical" />
      </button>
    }
  </div>
  <span class="component-small-medium text-center uppercase">{{ _computedState() }}</span>
</div>

<ng-template #dropdown>
  <hlm-dropdown-menu>
    <hlm-dropdown-menu-group>
      @for (action of actions(); track action.label) {
        <button (triggered)="action.execute(certification())" hlmDropdownMenuItem>
          <ng-icon [name]="action.icon" hlm hlmMenuIcon />
          {{ action.label }}
        </button>
      }
    </hlm-dropdown-menu-group>
  </hlm-dropdown-menu>
</ng-template>
